import Marquee from "react-fast-marquee";

const words = ["STRENGTH", "DISCIPLINE", "POWER", "ENDURANCE", "GRIT", "SPEED", "FOCUS"];

export default function BrandMarquee() {
  return (
    <section className="border-y border-[#222] bg-[#050505] py-8 md:py-12" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-6xl md:text-8xl text-stroke px-8">{w}</span>
            <span className="font-display text-6xl md:text-8xl text-[#005EEA] px-8">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
